var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('select',{staticClass:"custom-select custom-select-sm",class:[
    _vm.value === true
      ? 'bg-primary text-white'
      : _vm.value === null
      ? 'bg-danger text-white'
      : ''
  ],domProps:{"value":_vm.value},on:{"change":function($event){_vm.$emit(
      'input',
      $event.target.value.length === 0
        ? null
        : JSON.parse($event.target.value)
    )}}},[_c('option',{domProps:{"value":null}},[_vm._v("-")]),_c('option',{domProps:{"value":true}},[_vm._v("Yes")]),_c('option',{domProps:{"value":false}},[_vm._v("No")])])}
var staticRenderFns = []

export { render, staticRenderFns }